import { useEffect } from 'react';
import { useWorkstationID } from 'hooks/useWorkstationID';
import { useLocation, useNavigate } from 'react-router-dom';

export const useCaptureWorkstationIDFromQuery = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { clearWorkstationID, saveWorkstationID } = useWorkstationID();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const workstationID = searchParams.get('workstation_id');
    const hasWorkstationIDParam = searchParams.has('workstation_id');

    if (workstationID != null) {
      const saveResult = saveWorkstationID(workstationID);

      if (saveResult.ok === false) {
        clearWorkstationID();
      }
    }

    if (hasWorkstationIDParam) {
      searchParams.delete('workstation_id');
      const search = searchParams.toString();

      navigate(
        {
          pathname: location.pathname,
          search: search === '' ? '' : `?${search}`,
          hash: location.hash,
        },
        { replace: true, state: location.state }
      );
    }
  }, [
    location.hash,
    location.pathname,
    location.search,
    location.state,
    navigate,
    clearWorkstationID,
    saveWorkstationID,
  ]);
};
